import {removeExpedientNote} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";
import {expedientKeys, expedientMutationKeys} from "../../../../../expedient-keys";

export function removeExpedientNoteMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: expedientMutationKeys.removeExpedientNote,
    mutationFn: (memberId: number) => removeExpedientNote(id, memberId),
    onSuccess: async (_result, _payload, _context, {client}) => {
      await client.invalidateQueries({queryKey: expedientKeys.detail(id)});
    },
  });
}
